import { styled, css } from 'styled-components';
import { Link } from '@fabric-app/compat';

const LinkTouch = styled(Link).attrs((props) => {
  return {
    ...props,
    draggable: props.enableTouchDefaults ? true : false
  };
}).withConfig({
  displayName: "LinkTouch",
  componentId: "sc-91bc62e3-0"
})([
  ``,
  ``
], (p) => !p.enableTouchDefaults && css([
  `-webkit-touch-callout:none !important;-webkit-user-select:none !important;user-select:none !important;`
]));

export { LinkTouch };
//# sourceMappingURL=LinkTouch.js.map
